import router from '@/router'
// console.log(router, "444");
router.beforeEach((to, from, next) => {
    // console.log(to, 777);
    if (sessionStorage.sessionId) {
        next()
    } else {
        next()
    }
})


// WEBPACK FOOTER //
// ./src/util/routerEach.js